import { IPublicClientApplication } from '@azure/msal-browser';
import { Organization } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createJointNominee, deleteJointNominee } from './index';

export const createNominationJointNomineesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createJointNominee: (instance: IPublicClientApplication, nominationId: number, organization: Organization) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createJointNominee(fetchContext, nominationId, organization, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createJointNominee', isInFlight);
    },
  ),
  deleteJointNominee: (instance: IPublicClientApplication, nominationId: number, jointNomineeId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteJointNominee(fetchContext, nominationId, jointNomineeId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteJointNominee', isInFlight);
    },
  ),
});
